import React from "react";
import { motion } from "framer-motion";

const GlassCard = ({ icon: Icon, title, desc, onClick, background }) => (
  <motion.div
    whileHover={{ scale: 1.03, y: -2 }}
    whileTap={{ scale: 0.98 }}
    transition={{ duration: 0.15 }}
    onClick={onClick}
    className="
      glass-card cursor-pointer relative overflow-hidden group flex flex-col 
      items-center justify-center text-center rounded-2xl
      w-full max-w-[360px] mx-auto
      h-[240px] sm:h-[250px] md:h-[260px]
    "
  >
    {/* 🔹 Background layer */}
    {background && (
      <div
        className="absolute inset-0 bg-cover bg-center opacity-60 group-hover:opacity-80 transition-opacity duration-300"
        style={{ backgroundImage: `url(${background})` }}
      />
    )}
    <div className="absolute inset-0 bg-black/20" />

    {/* 🔹 Foreground content */}
    <div className="relative z-10 p-4 flex flex-col items-center justify-center h-full w-full">
      {Icon && (
        <div className="flex justify-center mb-3">
          <Icon className="text-blue-300 text-4xl sm:text-5xl" />
        </div>
      )}

      {/* ✅ Title */}
      <h2
        className="
          font-semibold text-gray-100 leading-snug transition-all duration-300
          text-[1.3rem] sm:text-[1.5rem] md:text-[1.6rem]
          max-w-[90%] whitespace-normal break-words
          group-hover:text-blue-200
        "
      >
        {title}
      </h2>

      {/* ✅ Description */}
      <p
        className="
          text-gray-200 font-light mt-2
          text-[0.95rem] sm:text-[1rem]
          leading-tight max-w-[90%]
        "
      >
        {desc}
      </p>
    </div>
  </motion.div>
);

export default GlassCard;
